// extracted by mini-css-extract-plugin
export var disabled = "_sa-0";